/* eslint-disable import/no-unresolved */
import { Hint, Box } from "@ui-kit/components/index.es";
import Card from "pages/_components/Card/Card";
import ContextMenu from "pages/_components/ContextMenu";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import I18n from "pages/_components/I18n";
import InfoTag from "pages/_components/InfoTag";
import { bool, func, node, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as transactionsActions } from "reducers/transactions";
import * as configUtils from "util/config";
import * as i18nUtils from "util/i18n";
import { getMultipleTransfersI18nKey } from "util/multiple-transfers";
import { findScheduleDesc } from "util/scheduler";
import { getTransferActivityName } from "util/transferInternalTitleLabels";
import {
    isTransactionPendingProcessing,
    isMvp3PendingTransactionsEnabled,
    isMvp5PendingTransactionsEnabled,
} from "util/transaction";
import TransactionAditionalInfo from "./TransactionAditionalInfo";
import TransactionCustomInfo from "./TransactionCustomInfo";
import TransactionFrom from "./TransactionFrom";
import TransactionTo from "./TransactionTo";

const idActivities = [
    "account.checks",
    "accounts.opening",
    "pay.multiline.send",
    "administration.signatures.create.send",
    "administration.signatures.modify.send",
    "administration.signatures.delete.send",
    "administration.restrictions.user.delete.send",
    "administration.restrictions.manage.send",
    "administration.simple.modify.permissions.send",
    "administration.medium.modify.permissions.send",
    "administration.medium.modify.signature.send",
    "administration.medium.modify.channels.send",
    "administration.users.invite.send",
    "administration.users.update",
    "administration.users.blockunblock.send",
    "administration.users.delete.send",
    "administration.advanced.group.modify.send",
    "administration.groups.delete.send",
    "administration.groups.blockunblock.send",
    "administration.advanced.group.modify.send",
    "administration.groups.modify.send",
    "administration.advanced.group.create.send",
];
const activitiesEcheqsWithPaymentDate = [
    "accept.return.echeqs",
    "emit.echeq.activity",
    "cesion.echeq.activity",
    "endorse.echeq.activity",
    "negotiate.echeq.activity",
];
const externalActivities = [
    "external.emit.echeq.activity",
    "external.emit.massive.echeq.activity",
    "send.external.transaction",
];
const isExternalChannelTransaction = (idActivity, data, channel) =>
    externalActivities.includes(idActivity) || data?.externalChannel === true || channel === "externo";
const credinActivitiesWithTrailingMobileSignatureHint = ["credin.sentRequest.send", "credinCVU.sentRequest.send"];

class CardTransactionsItem extends Component {
    static propTypes = {
        transaction: shape({
            cancelEnabled: string.isRequired,
            transaction: shape({
                creationDateTime: string,
                submitDateTime: string,
                activityName: string,
                idTransactionStatus: string,
            }),
            transactionAmounts: shape(),
        }).isRequired,
        activeEnvironment: shape().isRequired,
        administrationScheme: string.isRequired,
        checks: node.isRequired,
        isDesktop: bool.isRequired,
        dispatch: func.isRequired,
    };

    getAditionalInfo = () => {
        const { transaction: propsTransaction, administrationScheme } = this.props;
        const {
            transaction: { data, idActivity },
        } = propsTransaction;

        if (idActivities.includes(idActivity)) {
            return "";
        }
        const returnContent = TransactionAditionalInfo?.[idActivity];
        return returnContent ? returnContent(data, administrationScheme) : "";
    };

    getBottomInfo = () => {
        const { transaction: propsTransaction, administrationScheme, activeEnvironment, isDesktop } = this.props;
        const {
            transaction: { data, idActivity },
        } = propsTransaction;
        const showDataAdditionalEcomex = configUtils.getBoolean("frotend.show.divisa.amount.Ecomex");
        const showBeneficiaryEcomex = configUtils.getBoolean("frontend.show.beneficiary.ecomex", false);
        if (idActivity === "ecomex.send.accept.transaction" && (showDataAdditionalEcomex || showBeneficiaryEcomex)) {
            const returnContent = TransactionCustomInfo?.[idActivity];
            return returnContent ? returnContent(data, administrationScheme, activeEnvironment, isDesktop) : "";
        }
        if (idActivity !== "ecomex.send.accept.transaction") {
            const returnContent = TransactionCustomInfo?.[idActivity];
            return returnContent ? returnContent(data, administrationScheme, activeEnvironment, isDesktop) : "";
        }
        return "";
    };

    getFrom = () => {
        const { transaction: propsTransaction } = this.props;
        const {
            transaction: { data, idActivity },
        } = propsTransaction;
        const returnContent = TransactionFrom?.[idActivity];
        return returnContent ? returnContent(data) : "";
    };

    getTo = () => {
        const { transaction: propsTransaction } = this.props;
        const {
            transaction: { data, idActivity },
        } = propsTransaction;
        const returnContent = TransactionTo?.[idActivity];
        return returnContent ? returnContent(data) : "";
    };

    renderContexMenu = ({ idTransaction }) => {
        const { dispatch } = this.props;
        const items = [
            {
                label: "transactions.list.actions.delete",
                onClick: () => {
                    dispatch(transactionsActions.deleteDraftRequest(idTransaction));
                },
                icon: "Trash",
            },
        ];
        return <ContextMenu imageStyle="pr-0" items={items} />;
    };

    render() {
        const { transaction: propsTransaction, checks, isDesktop } = this.props;
        const { transaction, transactionAmounts } = propsTransaction;
        const {
            creationDateTime,
            activityName,
            programed,
            idTransactionStatus,
            nextExecutionDate,
            draftTransaction,
            idActivity,
            data: {
                checkBookChecksAmount,
                cbuList,
                toContact,
                echeqList,
                echeqsToEmit,
                isInsufficientbalance,
                fecha_pago: fechaPagoRoot,
            },
        } = transaction;
        const isMvp5LimitIncreaseRow =
            idActivity === "temporary.limit.increase.request" && isMvp5PendingTransactionsEnabled();
        const isPendingProcessing = isTransactionPendingProcessing(transaction);
        const transactionStatusForIcon = isPendingProcessing ? "PROCESSING" : idTransactionStatus;

        const [echeq] = echeqList || echeqsToEmit || [];
        const requestCertificateFechaPago =
            idActivity === "echeq.request-certificate.action"
                ? echeq?.fecha_pago || echeq?.date || fechaPagoRoot || echeqList?.[0]?.fecha_pago
                : null;

        let currency;
        let amount;
        let showAmount = amount !== 0;
        const enableNonDeductLimits = configUtils.getBoolean("frontend.ecomex.check.nonDeduct.limits", false);
        const showEcomexAdditionalData = configUtils.getBoolean("frotend.show.divisa.amount.Ecomex");

        if (activityName === "Aceptar DEBIN") {
            currency = transaction?.data?.currency;
            amount = transactionAmounts[currency];
        } else {
            currency =
                activityName === "CREDIN" && draftTransaction && cbuList?.length
                    ? cbuList[0].amount.currency
                    : Object.keys(transactionAmounts)[0];

            amount =
                activityName === "CREDIN" && draftTransaction
                    ? cbuList?.reduce((acc, val) => val.amount.quantity + acc, 0)
                    : transactionAmounts[currency];
        }

        if (activityName === "Comercio Exterior") {
            if (showEcomexAdditionalData) {
                const td = transaction?.data?.transactionData;
                const reqCur = td?.requestCurrency;
                const reqAmt = td?.requestAmount;
                const parsed =
                    typeof reqAmt === "number" && Number.isFinite(reqAmt)
                        ? reqAmt
                        : parseFloat(
                              String(reqAmt ?? "")
                                  .trim()
                                  .replace(/\s/g, "")
                                  .replace(",", "."),
                              10,
                          );
                if (reqCur != null && String(reqCur).trim() !== "" && Number.isFinite(parsed)) {
                    currency = String(reqCur).trim();
                    amount = parsed;
                    showAmount = true;
                } else {
                    showAmount = false;
                }
            } else if (enableNonDeductLimits) {
                showAmount = true;
            } else {
                showAmount = false;
            }
        }
        let toContactActivity;
        if (toContact) {
            if (idActivity === "transfers.thirdParties.tad.send" || idActivity === "ecomex.send.accept.transaction") {
                toContactActivity = i18nUtils.get("transfers.toContact.tad.send");
            } else {
                toContactActivity = i18nUtils.get("transfers.toContact.send");
            }
        }

        const titleCard = () => {
            const aditionalInfo = this.getAditionalInfo();
            const enableEcheqsPendingsPaymentDate = configUtils.getBoolean("frontend.show.echeqs.payment.date", false);
            const showMobileSignatureHint =
                isDesktop && isMvp3PendingTransactionsEnabled() && transaction?.data?.control;
            const mobileSignatureHintAfterAditionalInfo =
                showMobileSignatureHint && credinActivitiesWithTrailingMobileSignatureHint.includes(idActivity);

            return (
                <div
                    className={`card__pending-transaction-data-title ${
                        idTransactionStatus === "DRAFT" ? "space-between d-flex" : ""
                    }`}>
                    <div
                        className={`${
                            aditionalInfo && !isDesktop ? " d-flex flex-column" : "d-flex  align-items-center"
                        }${
                            mobileSignatureHintAfterAditionalInfo
                                ? " card__pending-transaction-data-title-row--wrap"
                                : ""
                        }`}>
                        <div
                            className={
                                aditionalInfo
                                    ? "card__pending-transaction-data-creation-container"
                                    : `d-flex ${isDesktop ? "align-items-center" : "flex-column"}`
                            }>
                            {idTransactionStatus !== ("SCHEDULED" || "SCHEDULED_RECURRENT") && (
                                <>
                                    <div className="d-flex">
                                        <I18n
                                            componentProps={{ className: "card__pending-transaction-data-creation" }}
                                            id="transactions.list.header.creationDate"
                                        />
                                        <FormattedDate showTime date={creationDateTime} />
                                        {showMobileSignatureHint && !mobileSignatureHintAfterAditionalInfo && (
                                            <Box ml={8}>
                                                <Hint
                                                    text={configUtils.get(
                                                        "frontend.mobileSignatureControl.tooltip",
                                                        "",
                                                    )}
                                                    colorIcon="dark"
                                                    colorText="dark"
                                                    iconVariant="outline"
                                                    ml="2"
                                                />
                                            </Box>
                                        )}
                                    </div>
                                    {(requestCertificateFechaPago ||
                                        (enableEcheqsPendingsPaymentDate &&
                                            activitiesEcheqsWithPaymentDate.includes(idActivity) &&
                                            echeq)) && (
                                        <div className="d-flex">
                                            {isDesktop && <span className="px-2">|</span>}
                                            <I18n
                                                componentProps={{
                                                    className: "card__pending-transaction-data-creation",
                                                }}
                                                id="transactions.list.header.paymentDate"
                                                defaultValue="Fecha de pago"
                                            />
                                            <FormattedDate
                                                showTime={false}
                                                date={requestCertificateFechaPago || echeq.fecha_pago || echeq.date}
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                            {isDesktop && idTransactionStatus === ("SCHEDULED" || "SCHEDULED_RECURRENT") && (
                                <>
                                    <I18n
                                        componentProps={{ className: "card__pending-transaction-data-creation mr-0" }}
                                        id="transactions.list.header.creationDate"
                                    />
                                    <FormattedDate date={creationDateTime} />
                                    <I18n
                                        componentProps={{
                                            className: "card__pending-transaction-data-creation card-separator",
                                        }}
                                        id="transactions.list.header.nextExecutionDate"
                                    />
                                    <FormattedDate date={nextExecutionDate} />
                                </>
                            )}
                        </div>
                        {!isDesktop && idTransactionStatus === ("SCHEDULED" || "SCHEDULED_RECURRENT") && (
                            <div className="d-flex flex-column">
                                <div className="d-flex">
                                    <I18n
                                        componentProps={{ className: "card__pending-transaction-data-creation" }}
                                        id="transactions.list.header.creationDate"
                                    />
                                    <FormattedDate date={creationDateTime} />
                                </div>
                                <div className="d-flex">
                                    <I18n
                                        componentProps={{
                                            className: "card__pending-transaction-data-creation",
                                        }}
                                        id="transactions.list.header.nextExecutionDate"
                                    />
                                    <FormattedDate date={nextExecutionDate} />
                                </div>
                            </div>
                        )}
                        {isDesktop && aditionalInfo && <span className="px-2">|</span>}
                        {programed && isDesktop && (
                            <InfoTag
                                type="default"
                                message={findScheduleDesc(transaction?.program?.frequency?.frequencyUnit)}
                            />
                        )}
                        {aditionalInfo && (
                            <div
                                className={`${
                                    isDesktop
                                        ? "card__pending-transaction-aditional-info"
                                        : "card__pending-transaction-aditional-info mt-1"
                                }${
                                    credinActivitiesWithTrailingMobileSignatureHint.includes(idActivity)
                                        ? " card__pending-transaction-aditional-info--credin"
                                        : ""
                                }`}>
                                {aditionalInfo}
                            </div>
                        )}
                        {mobileSignatureHintAfterAditionalInfo && (
                            <Box className="card__pending-transaction-mobile-signature-hint-trailing" ml={8}>
                                <Hint
                                    text={configUtils.get("frontend.mobileSignatureControl.tooltip", "")}
                                    colorIcon="dark"
                                    colorText="dark"
                                    iconVariant="outline"
                                    ml="2"
                                />
                            </Box>
                        )}
                    </div>
                    {!isDesktop && idTransactionStatus === "DRAFT" && this.renderContexMenu(transaction)}
                </div>
            );
        };

        let cardContent;
        const showDataAdditionalEcomex = configUtils.getBoolean("frotend.show.divisa.amount.Ecomex");
        const insufficientbalance = configUtils.getBoolean(
            "frontend.show.transfers.insufficientbalance.functionalities",
        );

        if (activityName === "Comercio Exterior" && showDataAdditionalEcomex) {
            const concept = transaction?.data?.transactionData?.concept;
            cardContent = concept ? `${activityName} | ${concept}` : activityName;
        } else if (idActivity === "transfer.multiple.send") {
            cardContent = i18nUtils.get(getMultipleTransfersI18nKey("activities.transfer.multiple.send"));
        } else {
            cardContent = toContactActivity || getTransferActivityName(idActivity, activityName);
        }

        const contentCard = () => (
            <>
                <div
                    className={`card__pending-transaction-data-description ${
                        isDesktop
                            ? "d-flex align-items-center flex-nowrap"
                            : "d-flex flex-row align-items-center justify-content-between card__pending-transaction-data-description--mobile-stack"
                    }`}>
                    <span className="card__pending-transaction-data-description__title-text">{cardContent}</span>
                    {isExternalChannelTransaction(idActivity, transaction.data, transaction.channel) && (
                        <InfoTag
                            type="default"
                            message={i18nUtils.get("transactions.list.external.label", "Canal externo")}
                            tagClass="external-channel-tag"
                            capitalize
                        />
                    )}
                </div>
            </>
        );

        const bottomCard = () => (
            <>
                <div
                    className={`card__pending-transaction-data-bottom${
                        isMvp5LimitIncreaseRow ? " card__pending-transaction-data-bottom--mvp5-limit" : ""
                    }`}>
                    {this.getBottomInfo()}
                </div>
                <div className="d-flex align-items-center">
                    {programed && !isDesktop && (
                        <InfoTag
                            type="default"
                            message={findScheduleDesc(transaction?.program?.frequency?.frequencyUnit)}
                        />
                    )}
                </div>
            </>
        );

        const contentRight = () => (
            <div className="card__component-item-currency d-flex flex-column align-items-end">
                {/* Alerta de Saldo Insuficiente */}
                {insufficientbalance && isInsufficientbalance === true && (
                    <div className="mb-1">
                        <Hint
                            type="Warning"
                            colorText="dark"
                            colorIcon="dark"
                            iconVariant="outline"
                            text={i18nUtils.get("transfers.pending.list.isInsufficientbalance")}
                        />
                    </div>
                )}
                {idTransactionStatus === "PENDING" && isPendingProcessing && (
                    <div className="mb-1">
                        <Hint
                            type="Info"
                            colorText="dark"
                            colorIcon="dark"
                            iconVariant="fill"
                            text={i18nUtils.get("transactions.pending.list.processing")}
                        />
                    </div>
                )}
                <div className="d-flex align-items-center">
                    {showAmount && currency && <FormattedAmount currency={currency} quantity={amount} />}
                    {checkBookChecksAmount || undefined}
                    {isDesktop && idTransactionStatus === "DRAFT" && (
                        <button type="button" className="btn btn-link p-0 m-0" onClick={(e) => e.stopPropagation()}>
                            {this.renderContexMenu(transaction)}
                        </button>
                    )}
                </div>
            </div>
        );

        return (
            <>
                <Card
                    isDesktop={isDesktop}
                    className={`card__pending-transaction${
                        isMvp5LimitIncreaseRow ? " card__pending-transaction--mvp5-limit-row" : ""
                    }`}
                    icon={`images/transfer-${transactionStatusForIcon}.svg`}
                    iconClass="card__pending-transaction-icon"
                    rightArrow={idTransactionStatus !== "DRAFT"}
                    title={titleCard()}
                    content={contentCard()}
                    bottom={bottomCard()}
                    rightContent={contentRight()}
                    checks={checks}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    administrationScheme: sessionSelectors.getAdministrationScheme(state),
});

export default connect(mapStateToProps)(CardTransactionsItem);
